import { LuckyCardButton } from '../LuckyCardButton';
import { LuckyPigeonButton } from '../LuckyPigeonButton';
import { WheelOfFortuneButton } from '../WheelOfFortuneButton';
import { DailyBonusButton } from '../DailyBonusButton';
import { FruitBonanzaButton } from '../FruitBonanzaButton';
import { VendingMachineButton } from '../VendingMachineButton';
import { isDev, isProductionEnv } from 'src/api';
import { useEvent } from 'src/context/usePromoEvent';
import { useAreAllGamesAvailable } from 'src/EXPERIMENTAL_LIB/modules/gpt/games/hooks/useAreAllGamesAvailable';
import { useIsMutating } from '@tanstack/react-query';
import classNames from 'classnames';

export const GPTButtonsBlock = () => {
  const isAuthenticationInProgress = useIsMutating({ mutationKey: ['login-mutation'] });
  const { eventActive } = useEvent();
  const isEvent = eventActive.eventDays;
  const isEventWheel = eventActive.eventWheel;
  const isEventPigeon = eventActive.eventPigeon;
  const isEventPigeonSecond = eventActive.eventPigeonSecond;
  const { areAllGamesAvailable } = useAreAllGamesAvailable();

  if (isAuthenticationInProgress || !areAllGamesAvailable) return null;

  return (
    <div className="flex w-full flex-col items-center justify-center gap-1">
      <LuckyCardButton isEventActive={!isEventPigeon && !isEventPigeonSecond && isEvent} />
      <LuckyPigeonButton isEventActive={isEventPigeon || isEventPigeonSecond} />
      <div
        className={classNames(
          'flex w-full items-center gap-1 justify-center',
          isEvent && 'flex-col'
        )}>
        <WheelOfFortuneButton isEventActive={isEventWheel} />
        <DailyBonusButton isEventActive={isEvent} />
      </div>
      {(!isProductionEnv || isDev) && <FruitBonanzaButton />}
      <VendingMachineButton isEventActive={isEvent} />
    </div>
  );
};
